// ======================================================================
// File: IndentFormDrawer.jsx
// Module: PPE → Procurement → Indent
// ======================================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import indentService from "../services/indentService";

import INDENT_TYPE from "../enums/indentType";
import INDENT_SOURCE from "../enums/indentSource";
import INDENT_STATUS from "../enums/indentStatus";

import Select from "react-select";
import { getDepartmentsByLocation } from "../../../../../../services/departmentService";

import { useContext } from "react";
import { AuthContext } from "../../../../../../context/AuthContext";

import { getProjects } from "../../../../../pms/services/projectService";
import { getOrders } from "../../../../../ipe/order/services/ipeOrderService";

export default function IndentFormDrawer({
  open,
  mode = "create",
  record = null,
  onClose,
  onSaved,
}) {
  const navigate = useNavigate();
  const { activeScope } = useContext(AuthContext);

  // --------------------------------------------------
  // FORM STATE
  // --------------------------------------------------
  const today = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState({
    indent_date: today,
    indent_type: INDENT_TYPE.PRODUCTION,
    indent_source: INDENT_SOURCE.MANUAL,
    department_id: "",
    required_date: "",
    remarks: "",
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [departments, setDepartments] = useState([]);

  const [projects, setProjects] = useState([]);
const [orders, setOrders] = useState([]);
const [selectedProject, setSelectedProject] = useState(null);
const [selectedOrder, setSelectedOrder] = useState(null);

  // --------------------------------------------------
  // INIT FORM
  // --------------------------------------------------
  useEffect(() => {
    if (mode === "edit" && record) {
      setForm({
        indent_date: record.indent_date || "",
        indent_type:
          record.indent_type ||
          INDENT_TYPE.PRODUCTION,
        indent_source:
          record.indent_source ||
          INDENT_SOURCE.MANUAL,
        department_id: record.department_id || "",
        required_date: record.required_date || "",
        remarks: record.remarks || "",
      });
    } else {
      setForm({
        indent_date: today,
        indent_type: INDENT_TYPE.PRODUCTION,
        indent_source: INDENT_SOURCE.MANUAL,
        department_id: "",
        required_date: "",
        remarks: "",
      });
    }
  }, [mode, record]);

  
  // LOAD DEPARTMENTS
useEffect(() => {
  if (
    activeScope?.tenant_id &&
    activeScope?.location_id
  ) {
    loadDepartments();
  }
}, [
  activeScope?.tenant_id,
  activeScope?.location_id,
]);
useEffect(() => {
  if (
    //mode !== "create" ||
    form.indent_source !== INDENT_SOURCE.BOQ
  ) {
    return;
  }

  const loadBOQMasters = async () => {
  try {
    const [projectResponse, orderResponse] =
      await Promise.all([
        getProjects(),
        getOrders(),
      ]);

    const projectList =
      projectResponse?.data?.data || [];

    const orderList =
      orderResponse?.data?.data?.items || [];

    setProjects(projectList);
    setOrders(orderList);

    // --------------------------------------------------
    // RESTORE BOQ PROJECT / ORDER IN EDIT MODE
    // reference_id stores the project_id
    // --------------------------------------------------
    
    console.log(
  "BOQ EDIT - record:",
  record
);

console.log(
  "BOQ EDIT - reference_id:",
  record?.reference_id
);

console.log(
  "BOQ EDIT - projectList:",
  projectList
);
    if (
      mode === "edit" &&
      record?.reference_id
    ) {
      const project = projectList.find(
        (p) =>
          String(p.id) ===
          String(record.reference_id)
      );

      if (project) {
        const projectOption = {
          value: project.id,
          label: project.project_name,
          order_no: project.order_no,
        };

        setSelectedProject(projectOption);

        const order = orderList.find(
          (o) =>
            String(o.order_no) ===
            String(project.order_no)
        );

        if (order) {
          setSelectedOrder({
            value: order.id,
            label: order.order_no,
          });
        }
      }
    }
  } catch (err) {
    console.error(
      "Failed to load BOQ projects/orders:",
      err
    );

    setProjects([]);
    setOrders([]);
  }
};

  loadBOQMasters();
}, [
  mode,
  form.indent_source,
  record?.reference_id,
]);

const loadDepartments = async () => {
  try {

    console.log(
      "tenant_id:",
      activeScope?.tenant_id,
      "location_id:",
      activeScope?.location_id
    );

    const depData =
      await getDepartmentsByLocation(
        activeScope?.tenant_id,
        activeScope?.location_id
      );

    console.log(
      "Department API Response:",
      depData
    );

    const options = (depData?.data || []).map((d) => ({
      value: d.id,
      label: d.name,
    }));

    console.log(
      "Department Options:",
      options
    );

    setDepartments(options);

  } catch (err) {
    console.error(
      "Failed to load departments",
      err
    );
  }
};
  
  if (!open) return null;

  const onChange = (field, value) => {
    setForm((p) => ({ ...p, [field]: value }));
  };

  const readOnly =
    mode === "edit" &&
    record?.status !== INDENT_STATUS.DRAFT;

  
  
    // --------------------------------------------------
  // SAVE
  // --------------------------------------------------
  const handleSave_old = async () => {
    setError(null);

    try {
      setSaving(true);
      
      const response =
        mode === "edit"
          ? await indentService.updateIndent(
              record.id,
              form
            )
          : await indentService.createIndent(form);

      onSaved?.(response);
      onClose();

      navigate(
        `/ppe/procurement/indent/${response.id}`
      );
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Failed to save indent"
      );
    } finally {
      setSaving(false);
    }
  };
const handleSave = async () => {
  setError(null);

  try {
    setSaving(true);

    let response;

    if (mode === "edit") {
      response = await indentService.updateIndent(
        record.id,
        form
      );
    } else if (
      form.indent_source === INDENT_SOURCE.BOQ
    ) {
      if (!selectedProject) {
        throw new Error("Please select a Project");
      }

      if (!selectedOrder) {
        throw new Error("Please select an Order");
      }

      response =
        await indentService.createIndentFromBOQ(
          selectedProject.value,
          selectedOrder.value,
          form.department_id,
          form.indent_date,
          form.indent_type
        );
    } else {
      response =
        await indentService.createIndent(form);
    }

    onSaved?.(response);
    onClose();

    navigate(
      `/ppe/procurement/indent/${response.id}?edit=true`
    );
  } catch (err) {
    setError(
      err?.response?.data?.message ||
        err?.message ||
        "Failed to save indent"
    );
  } finally {
    setSaving(false);
  }
};
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: 520,
        height: "100vh",
        background: "#fff",
        boxShadow: "-4px 0 16px rgba(0,0,0,0.15)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: 16,
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h6 style={{ margin: 0 }}>
          {mode === "edit"
            ? "Edit Indent"
            : "Create Indent"}
        </h6>

        <button
          className="btn btn-sm btn-light"
          onClick={onClose}
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div
        style={{
          padding: 16,
          flex: 1,
          overflowY: "auto",
        }}
      >
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {/* INDENT DATE */}
        <div className="mb-3">
          <label className="form-label">
            Indent Date
          </label>
          <input
            type="date"
            className="form-control"
            value={form.indent_date}
            readOnly
            disabled={readOnly}
            onChange={(e) =>
              onChange("indent_date", e.target.value)
            }
          />
        </div>

        {/* ✅ FIXED INDENT TYPE */}
        <div className="mb-3">
          <label className="form-label">
            Indent Type
          </label>
          <select
            className="form-select"
            value={form.indent_type}
            disabled={readOnly}
            onChange={(e) =>
              onChange(
                "indent_type",
                e.target.value
              )
            }
          >
            {Object.values(INDENT_TYPE).map(
              (t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              )
            )}
          </select>
        </div>

        {/* SOURCE */}
        <div className="mb-3">
          <label className="form-label">
            Indent Source
          </label>
          <select
            className="form-select"
            value={form.indent_source}
            disabled={readOnly}
            onChange={(e) =>
              onChange(
                "indent_source",
                e.target.value
              )
            }
          >
            {Object.values(INDENT_SOURCE).map(
              (s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              )
            )}
          </select>
        </div>

                {/* BOQ PROJECT */}
        {form.indent_source === INDENT_SOURCE.BOQ && (
          <div className="mb-3">
            <label className="form-label">
              Project
            </label>

            <Select
              options={projects.map((p) => ({
                value: p.id,
                label: p.project_name,
                order_no: p.order_no,
              }))}
              isDisabled={readOnly}
              placeholder="Select Project"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={selectedProject}
              onChange={(selected) => {
                setSelectedProject(selected);
                setSelectedOrder(null);
              }}
            />
          </div>
        )}

        {/* BOQ ORDER */}
        {form.indent_source === INDENT_SOURCE.BOQ && (
          <div className="mb-3">
            <label className="form-label">
              Order
            </label>

            <Select
              options={orders
                  .filter(
                    (o) =>
                      selectedProject &&
                      String(o.order_no) ===
                        String(selectedProject.order_no)
                  )
                .map((o) => ({
                  value: o.id,
                  label: o.order_no,
                }))}
              isDisabled={
                readOnly || !selectedProject
              }
              placeholder={
                selectedProject
                  ? "Select Order"
                  : "Select Project first"
              }
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={selectedOrder}
              onChange={(selected) => {
                setSelectedOrder(selected);
              }}
              
            />
          </div>
        )}    

        {/* DEPARTMENT */}
        {/* DEPARTMENT */}
          <div className="mb-3">
            <label className="form-label">
              Department
            </label>

            {/* Debug 
            <small className="text-muted">
              Loaded Departments: {departments.length}
            </small>
            */}    
            <Select
              options={departments}
              isDisabled={readOnly}
              placeholder="Select Department"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={
                departments.find(
                  (d) =>
                    String(d.value) ===
                    String(form.department_id)
                ) || null
              }
              onChange={(selected) =>
                onChange(
                  "department_id",
                  selected?.value || ""
                )
              }
            />
          </div>

        {/* REQUIRED DATE */}
        <div className="mb-3">
          <label className="form-label">
            Required Date
          </label>
          <input
            type="date"
            className="form-control"
            value={form.required_date}
            disabled={readOnly}
            onChange={(e) =>
              onChange(
                "required_date",
                e.target.value
              )
            }
          />
        </div>

        {/* REMARKS */}
        <div className="mb-3">
          <label className="form-label">
            Remarks
          </label>
          <textarea
            rows={3}
            className="form-control"
            value={form.remarks}
            disabled={readOnly}
            onChange={(e) =>
              onChange("remarks", e.target.value)
            }
          />
        </div>
      </div>

      {/* FOOTER */}
      <div
        style={{
          padding: 16,
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        <button
          className="btn btn-outline-secondary"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </button>

        {!readOnly && (
          <button
            className="btn btn-primary"
            disabled={saving}
            onClick={handleSave}
          >
            {saving ? "Saving…" : "Save"}
          </button>
        )}
      </div>
    </div>
  );
}
